import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/router/auth'

Vue.use(Router)

function checkSession(to, from, next) {
  if (Vue.prototype.$session.exists()) {
    auth.check()
      .then(res => {
        if (res) {
          next()
        } else {
          next('/login')
        }
      })
  }
  else {
    next('/login')
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      component: () => import(
        '@/pages/errors/404.vue'
      )
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import(`@/pages/Login.vue`),
      beforeEnter(to, from, next) {
        if (Vue.prototype.$session.exists()) {
          auth.check()
            .then(res => {
              if (res) {
                next('/home')
              } else {
                next()
              }
            })
        }
        else {
          next()
        }
      }
    },
    {
      path: '/',
      name: 'Root',
      redirect: {
        name: 'Home'
      },
      component: () => import(`@/pages/Root.vue`),
      children: [
        {
          path: '/home',
          name: 'Home',
          component: () => import(`@/pages/Home.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/admin/catalogues',
          name: 'Catalogues',
          component: () => import(`@/pages/admin/Catalogues.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/admin/employees',
          name: 'Employees',
          component: () => import(`@/pages/admin/Employees.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/admin/instructors',
          name: 'Instructors',
          component: () => import(`@/pages/admin/Instructors.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/admin/events',
          name: 'Events',
          component: () => import(`@/pages/admin/Events.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/admin/reports',
          name: 'Reports',
          component: () => import(`@/pages/admin/Reports.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/admin/roles',
          name: 'Roles',
          component: () => import(`@/pages/admin/Roles.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/admin/permissions',
          name: 'Permisos',
          component: () => import(`@/pages/admin/Permissions.vue`),
          beforeEnter: checkSession
        },
        {
          path: '/admin/resources',
          name: 'Recursos',
          component: () => import(`@/pages/admin/Resources.vue`),
          beforeEnter: checkSession
        },
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  next();
});

router.afterEach((to, from) => {
});

export default router
